export default __webpack_public_path__ + "static/app-features-2-839c057693a57e4396da3fc4176c9ca1.png";